import buildUrl from 'spiceutils/dist/buildUrl'
import { URL } from '../../constants/api'
import FetchPath from './FetchPath'
import { getOffersFactory, getOfferByIdFactory, shareOfferFactory } from './offers'
import HttpCache from '../httpCache'
import fetchWrapper from './fetchWrapper'
import { authInitialiser } from '../auth'

export const fetchPath = new FetchPath(fetchWrapper, buildUrl, URL, HttpCache, authInitialiser)
export const getOffers = getOffersFactory(fetchPath)
export const getOfferById = getOfferByIdFactory(fetchPath)
export const shareOffer = shareOfferFactory(fetchPath)
export const getUserData = ({ accessToken }) => fetchPath.run({
  path: '/user/current',
  method: 'post',
  data: { accessToken },
  retryOnAuthError: false,
})
export const logout = () => fetchPath.run({
  path: '/user/logout',
  method: 'delete',
  retryOnAuthError: false,
})

authInitialiser.getUserData = getUserData

export default {
  getOffers,
  getOfferById,
  shareOffer,
  fetchPath,
  getUserData,
  logout,
}
